export default "__VITE_ASSET__DVbF9tfY__"